var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-card__content p-md-3" },
    [
      _c(
        "a",
        {
          ref: "title",
          staticClass: "card__title mb-2 font-weight-bold",
          attrs: { "data-line-clamp": "1", href: _vm.content.url }
        },
        [_vm._v("\n    " + _vm._s(_vm.processedContent.title) + "\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.processedContent.genres, function(genre) {
        return _c(
          "a",
          {
            key: genre.id,
            staticClass: "genre-block d-none d-sm-inline-block",
            attrs: {
              href: genre.url,
              "data-event-category": "discover",
              "data-event-action": "info",
              "data-event-label": genre.name
            }
          },
          [_vm._v("\n    " + _vm._s(genre.name) + "\n  ")]
        )
      }),
      _vm._v(" "),
      _vm.processedContent.reviewScore ||
      _vm.processedContent.rating ||
      _vm.processedContent.languages.length > 0
        ? _c("div", { staticClass: "mt-2 d-none d-sm-block" }, [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processedContent.reviewScore,
                  expression: "processedContent.reviewScore"
                }
              ],
              style: { "vertical-align": "unset" },
              attrs: {
                src: require("@/images/star.png"),
                alt: "review-star-icon",
                width: "12",
                height: "12"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.processedContent.reviewScore) +
                  "\n      " +
                  _vm._s(
                    _vm.processedContent.rating &&
                      _vm.processedContent.reviewScore &&
                      "|"
                  ) +
                  "\n      " +
                  _vm._s(_vm.processedContent.rating) +
                  "\n      " +
                  _vm._s(
                    (_vm.processedContent.rating ||
                      _vm.processedContent.reviewScore) &&
                      _vm.processedContent.languages.length > 0
                      ? "|"
                      : ""
                  ) +
                  "\n      " +
                  _vm._s(_vm.processedContent.languages.join(", ")) +
                  "\n    "
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }